import { G } from '@mobily/ts-belt'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

import { hours } from '@/const'
import { useDietsStore } from '@/store/dietsStore'

export const useMeals = () => {
  const dietStore = useDietsStore()
  const { diet } = storeToRefs(dietStore)
  const deleteMealModal = ref(false)
  const selectedMealIndex = ref<number>()
  const selectedMealName = ref('')
  const meals = computed(() => diet.value?.data.meals ?? [])
  const energyDistribution = computed(() => diet.value?.data.energy_distribution)
  const hourOptions = computed(() => Array.from(hours, hour => ({ text: hour, value: hour })))
  const energyDistributionCalories = (value: number) =>
    Math.round((value * (diet.value?.data.norms.calories ?? 0)) / 100)
  const showDeleteMealModal = (mealIndex: number, mealName: string) => {
    deleteMealModal.value = true
    selectedMealIndex.value = mealIndex
    selectedMealName.value = mealName
  }
  const hideDeleteMealModal = () => {
    deleteMealModal.value = false
    selectedMealIndex.value = undefined
    selectedMealName.value = ''
  }
  const handleDeleteMeal = () => {
    if (!G.isNumber(selectedMealIndex.value)) return
    dietStore.deleteMeal(selectedMealIndex.value)
    hideDeleteMealModal()
  }

  return {
    deleteMealModal,
    energyDistribution,
    energyDistributionCalories,
    handleCreateMeal: dietStore.createMeal,
    handleDeleteMeal,
    handleUpdateEnergyDistribution: () => {
      dietStore.updateEnergyDistribution(!energyDistribution.value)
    },
    hideDeleteMealModal,
    hourOptions,
    meals,
    selectedMealName,
    showDeleteMealModal,
  }
}
